<template>
    <div class="form_box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="模板名称" prop="name">
                <el-input v-model="ruleForm.name" style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="计费方式">
                <el-radio-group v-model="ruleForm.calcMode" @change="calcModeChange">
                    <el-radio :label="0">按重量计费</el-radio>
                    <el-radio :label="1">按件计费</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="物流公司" prop="expressId">
                <el-select style="width: 400px;" v-model="ruleForm.expressId" placeholder="请选择物流公司">
                    <el-option v-for="item in logisticList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="配送区域" prop="areaList">
                <el-table :data="ruleForm.areaList" style="width: 99.6%"
                    :header-cell-style="{background:'#F5F5F5',color:'#6A6B6A'}">
                    <el-table-column label="配送区域" prop="citys"></el-table-column>
                    <el-table-column align="center" :label="chooseRadio.firstNumName" width="90">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.firstNum" style="width: 70px;"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" :label="chooseRadio.firstPriceName" width="90">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.firstPrice" style="width: 70px;"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" :label="chooseRadio.secondNumName" width="90">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.secondNum" style="width: 70px;"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" :label="chooseRadio.secondPriceName" width="90">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.secondPrice" style="width: 70px;"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="90">
                        <template slot-scope="scope">
                            <div style="font-size: 18px;font-weight: 700;cursor: pointer;">
                                <i class="el-icon-edit" style="margin-right: 6px;" @click="edit_address(scope)"></i>
                                <i class="el-icon-close" @click="delete_address(scope)"></i>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-button style="margin-top: 6px;margin-left: 100px;" size="mini" type="primary" icon="el-icon-plus"
                @click="dialogVisible=true">
                新建配送区域</el-button>
            <el-form-item label="状态">
                <el-radio-group v-model="ruleForm.enable">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" icon="el-icon-document-checked" @click="submitForm('ruleForm')">
                    提交并返回</el-button>
                <el-button size="mini" icon="el-icon-refresh-left" @click="submitCancel">返回</el-button>
            </el-form-item>
        </el-form>
        <el-dialog @open="diaglog_show()" ref="dialog" title="选择配送区域" :visible.sync="dialogVisible" width="30%"
            :before-close="handleClose">
            <div v-if="dialogVisible">
                <el-tree ref="tree" :data="treeData" node-key="areaCode" :default-checked-keys="checkedKeys"
                    @check="treeClick" show-checkbox :props="defaultProps">
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddProvince">取 消</el-button>
                <el-button type="primary" @click="confirmAddProvince">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
let _this
import { getProvince, getLogistics, addLogistics, logisticsDetail, updateLogistics } from "@/request/api/logistics";
export default {
    data() {
        var validateAreas = (rule, value, callback) => {
            console.log(rule)
            if (value.length == 0) {
                return callback('请添加配送区域');
            }
            if (value.every(item => item.firstNum && item.firstPrice && item.secondNum && item.secondPrice)) {
                callback();
            } else {
                return callback('配送区域费用信息未填写');
            }
        };
        return {
            treeData: [],
            defaultProps: {
                children: 'subs',
                label: 'areaName',
                // disabled:true,
            },
            count: 1,
            dialogVisible: false,
            chooseRadio: {
                firstNumName: '首重(g)',
                firstPriceName: '首费(元)',
                secondNumName: '续重(g)',
                secondPriceName: '续费(元)'
            },
            addressIndex: null,
            logisticList: [],
            checkedKeys: [],
            chooseProvince: {},
            ruleForm: {
                name: '',
                calcMode: 0,//0重量  1件
                enable: 1,//1启用   0禁用
                // expressId: '', //物流公司id
                areaList: [],//配送区域
            },
            rules: {
                name: [
                    { required: true, message: '请选模板名称', trigger: 'blur' }
                ],
                // expressId: [
                //     { required: true, message: '请选择物流公司', trigger: 'change' }
                // ],
                areaList: [
                    { required: true, validator: validateAreas, trigger: 'change' }
                ],
            }
        }
    },
    watch: {
        'ruleForm.calcMode'(e) {
            console.log(e)
            if (this.ruleForm.calcMode == 0) {
                this.chooseRadio = {
                    firstNumName: '首重(g)',
                    firstPriceName: '首费(元)',
                    secondNumName: '续重(g)',
                    secondPriceName: '续费(元)'
                }
            } else {
                this.chooseRadio = {
                    firstNumName: '首件(个)',
                    firstPriceName: '运费(元)',
                    secondNumName: '续件(个)',
                    secondPriceName: '续费(元)'
                }
            }
        }
    },
    created() {
        _this = this
        if (this.$route.params.id != 0) {//编辑
            logisticsDetail(this.$route.params.id).then(res => {
                this.ruleForm = res.data
            })
        }
        getProvince().then(res => {
            console.log(res)
            this.treeData = res.data
        })
        getLogistics().then(res => {
            console.log(res.data)
            this.logisticList = res.data
        })
    },
    methods: {
        cancelAddProvince() {
            this.resetParams('chooseProvince')
            this.resetParams('addressIndex')
            this.resetParams('checkedKeys')
            console.log(this.chooseProvince)
            this.dialogVisible = false
        },
        confirmAddProvince() {
            if (this.chooseProvince.citysCode && this.chooseProvince.citys) {
                if (this.addressIndex != null) {
                    this.ruleForm.areaList[this.addressIndex].citys = this.chooseProvince.citys
                    this.ruleForm.areaList[this.addressIndex].citysCode = this.chooseProvince.citysCode
                } else {
                    this.ruleForm.areaList.push(this.chooseProvince)
                }
                this.dialogVisible = false
                this.resetParams('addressIndex')
                this.resetParams('chooseProvince')
                this.resetParams('checkedKeys')
            }
        },
        treeClick(data, node) {
            let obj = {
                citys: "",
                citysCode: "",
                firstNum: '',
                firstPrice: '',
                secondNum: '',
                secondPrice: ''
            }
            node.checkedNodes.forEach(item => {
                if (!item.subs) {
                    obj.citys ? obj.citys = obj.citys + ',' + item.areaName : obj.citys = item.areaName
                    obj.citysCode ? obj.citysCode = obj.citysCode + ',' + item.areaCode : obj.citysCode = item.areaCode
                }
            })
            this.chooseProvince = obj
        },
        handleClose() {

        },
        delete_address(e) {
            console.log(e)

            this.$confirm('确定要删除此配送区域吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ruleForm.areaList.splice(e.$index, 1)
            }).catch(() => {
            })
        },
        edit_address(e) {
            console.log(e)
            this.checkedKeys = e.row.citysCode.split(',')
            this.addressIndex = e.$index
            this.dialogVisible = true
        },
        diaglog_show() {
            setTimeout(() => {
                for (var n = 0; n < _this.treeData.length; n++) {//先全部不禁用再处理以下的
                    _this.treeData[n].subs.forEach(res => {
                        res.disabled = false
                    })
                }
                let arr = [] //目前已选区域
                _this.ruleForm.areaList.forEach(item => {
                    if (item.citysCode) {
                        arr = arr.concat(item.citysCode.split(','))
                    }
                })
                console.log(arr)
                if (_this.addressIndex != null) {//编辑某一个的
                    // 编辑的时候选择了哪个
                    console.log(_this.ruleForm.areaList[_this.addressIndex].citysCode.split(','))
                    let allArr = getArrDifference(_this.ruleForm.areaList[_this.addressIndex].citysCode.split(','), arr)
                    _this.$refs.tree.setCheckedKeys(_this.ruleForm.areaList[_this.addressIndex].citysCode.split(','))
                    disabled_handle(_this.treeData,allArr)
                } else {
                    _this.$refs.tree.setCheckedKeys([])//新增的时候都可选
                    console.log(arr)
                    disabled_handle(_this.treeData,arr)
                }
            }, 0)
        },
        calcModeChange(e) {
            console.log(e)
        },
        add_address() {
            // this.tableData.
        },
        resetParams(params) {
            this.$data[params] = this.$options.data()[params]
        },
        submitCancel() {
            this.$router.go(-1)
        },
        submitForm(formName) {
            console.log(this.ruleForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.$route.params.id != 0) {
                        //编辑
                        updateLogistics(this.ruleForm).then(res => {
                            console.log(res)
                            if (res.code == 0) {
                                this.$message.success(res.msg)
                                this.$router.go(-1)
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    } else {
                        addLogistics(this.ruleForm).then(res => {
                            console.log(res)
                            if (res.code == 0) {
                                this.$message.success(res.msg)
                                this.$router.go(-1)
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
function getArrDifference(arr1, arr2) {
    return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
    });
}
function disabled_handle(treeList,arrList) {
    for (var i = 0; i < treeList.length; i++) {
        treeList[i].subs.forEach(item => {
            for (var j = 0; j < arrList.length; j++) {
                if (arrList[j] == item.areaCode) {
                    item.disabled = true
                }
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.form_box /deep/ .el-form-item__content {
    line-height: 30px;
}

.form_box /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
}

.form_box /deep/ .el-input__icon {
    line-height: 30px;
}

.form_box /deep/ .el-form-item__label {
    line-height: 30px;
}

.form_box /deep/ .el-table .el-table__cell {
    padding: 6px 0;
}

// .form_box /deep/ .el-form-item__content{
//     line-height: 25px;
// }
.form_box {
    border-top: 1px solid #eeeeee;
    padding: 20px;
    background-color: #fff;
}
</style>